export enum Currency {
    USD = 0,
    CAD = 1
}
